import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: "name",
    className: "bold",
    render: (data, type, row, meta) => renderToString(
      <a href={row['url']}>{data}</a>
    )
  },
  {
    data: "phone_number",
  }
]

const headers = [
  'Name',
  'Phone Number'
]

const filters = [
]

const sorters = [
]

const order = [[ 0, "asc" ]]

export { columns, headers, filters, sorters, order }
